function numericField(value: string, minimum: number, maximum: number): number | null {
  if (!/^\d+$/.test(value)) return null
  const parsed = Number(value)
  return parsed >= minimum && parsed <= maximum ? parsed : null
}

function timezoneLabel(timezone: string | null): string {
  if (timezone === null) return ''
  return timezone === 'Asia/Tokyo' ? ' JST' : ` ${timezone}`
}

/**
 * Humanize only cron shapes whose meaning is unambiguous. The exact
 * expression remains the fallback, so a future catalog schedule can never be
 * described incorrectly just because this formatter has not learned it yet.
 */
export function describeJobSchedule(schedule: string | null, timezone: string | null): string {
  if (schedule === null) return 'Queued on demand'

  const fields = schedule.trim().split(/\s+/)
  if (fields.length !== 5) return `Cron ${schedule}`
  const [minuteField, hourField, dayOfMonth, month, dayOfWeek] = fields as [
    string,
    string,
    string,
    string,
    string,
  ]
  const everyDay = dayOfMonth === '*' && month === '*' && dayOfWeek === '*'

  const minuteStep = /^\*\/([1-9]\d*)$/.exec(minuteField)?.[1]
  if (minuteStep !== undefined && hourField === '*' && everyDay) {
    const minutes = Number(minuteStep)
    if (minutes <= 59) return `Every ${minutes} minute${minutes === 1 ? '' : 's'}`
  }

  const minute = numericField(minuteField, 0, 59)
  if (minute !== null && hourField === '*' && everyDay) {
    return `Hourly at :${String(minute).padStart(2, '0')}${timezoneLabel(timezone)}`
  }

  const hour = numericField(hourField, 0, 23)
  if (minute !== null && hour !== null && everyDay) {
    return `Daily at ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}${timezoneLabel(timezone)}`
  }

  return `Cron ${schedule}${timezoneLabel(timezone)}`
}
